import { Translation } from "@/types/types";
import { translate } from "./utils";


export const SEND_LANGS = ["en-US", "ca-ES", "gl-ES", "es-ES", "eu-ES"] as const;
export const SAVE_LANGS = ["en-US", "ca-ES", "ga-ES", "es-ES", "eu-ES"] as const;
export const toSaveCode = (code: string) => (code === "gl-ES" ? "ga-ES" : code);
export const toDisplayCode = (code: string) => (code === "ga-ES" ? "gl-ES" : code);

export function emptyRow(lang: string): Translation {
  return { lenguajes_code: lang } as Translation;
}
export function ensureLanguageRows(
  existing: Translation[] | undefined,
  languages: readonly string[]
): Translation[] {
  const byLang = new Map(
    (existing ?? []).map((t) => [t.lenguajes_code as string, t])
  );
  return languages.map((l) => byLang.get(l) ?? emptyRow(l));
}
export function normalizeToSaveCodes(rows?: Translation[]): Translation[] {
  if (!rows) return [];
  return rows.map((r) =>
    r.lenguajes_code === "gl-ES" ? { ...r, lenguajes_code: "ga-ES" } : r
  );
}
export function mergeTranslationsByKeysUnion(
  base: Translation[] | undefined,
  updates: Translation[] | undefined,
  keys: readonly string[],
  languages: readonly string[]
): Translation[] {
  const normalized = ensureLanguageRows(base, languages);
  const updByLang = new Map(
    (updates ?? []).map((u) => [toSaveCode(u.lenguajes_code as string), u])
  );
  return normalized.map((row) => {
    const upd = updByLang.get(row.lenguajes_code as string);
    if (!upd) return row;
    const patch: Record<string, any> = {};
    for (const k of keys)
      if (k in upd && typeof (upd as any)[k] === "string")
        patch[k] = (upd as any)[k];
    return { ...row, ...patch };
  });
}

export async function saveAndAutoTranslateField({
  field,
  value,
  userLang,
  element,
  tableName,
  refetch,
  updateElement,
  translateWithGPT,
}: {
  field: string;
  value: string;
  userLang: string;
  element: any;
  tableName: string;
  refetch: () => void;
  updateElement: (table: string, id: number, payload: any) => Promise<any>;
  translateWithGPT: (text: string) => Promise<{ translations: Record<string, string> }>;
}) {
  
  const current = element?.translations?.find((t: any) => t.lenguajes_code === userLang);
  if (!current?.id) return;

  try {
    await updateElement(tableName, Number(current.id), { [field]: value });
  } finally {
    refetch();
  }
  try {
   
    translate({
      phrase: value,
      field,
      element,
      tableName
    });
  } catch (err) {
    console.error(err);
  } 
}
